import { LlmUsageRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/billing/llm-usage')({
  component: LlmUsageRoute,
});
